import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {TasksApiPath, FEATURE_NAMESPACE} from '../../../consts'
import {ProcessWorkOrderCreateDto, ProcessWorkOrderDto} from '../../../types'
import {prepareProcessWorkOrderFormData} from '../../../utils/process-work-orders'
import {TasksQueryKey} from '../useTasks'

const INTERVAL = 400
const REPEATS = 5

export const useCreateProcessWorkOrder = () => {
  const queryClient = useQueryClient()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation<ProcessWorkOrderDto, AxiosError, ProcessWorkOrderCreateDto>({
    mutationFn: async (data) => {
      const plantId = data.plantId
      const path = `${TasksApiPath.PROCESS_WORK_ORDERS}/${plantId}/process-work-orders`
      // Prepare the form data
      const formData = await prepareProcessWorkOrderFormData(data)
      const {data: response} = await ApiClient.axiosInstance.post(path, formData)
      return response
    },
    onError: () => {
      spawnErrorToast(t('processWorkOrders.message.failedToAddProcessWorkOrder'))
    },
    onSuccess: async (data) => {
      if (data.isChecklistsCreationFailed) {
        spawnErrorToast(t('processWorkOrders.message.failedToCreateChecklists'))
      }
      spawnSuccessToast(t('processWorkOrders.message.processWorkOrderAdded'))

      const queries = queryClient.getQueriesData({queryKey: [TasksQueryKey]})
      for (let i = 0; i < REPEATS; i++) {
        await Promise.all(
          queries.map(([key]) => queryClient.refetchQueries({queryKey: key, exact: true}))
        )
        await new Promise((r) => setTimeout(r, INTERVAL))
      }
    }
  })
}
